
import { Component, Input, OnInit } from '@angular/core';
import { CategoryService } from 'src/app/services/category.service';
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import { Router, NavigationEnd } from "@angular/router";

@Component({
  selector: 'calsoft-cat-navigation',
  templateUrl: './cat-navigation.component.html',
  styleUrls: ['./cat-navigation.component.scss']
})
export class CatNavigationComponent implements OnInit {

  url = '';
  sanitizedUrl = '';

  categoryDetails: any;
  public items: any=[];

  constructor(
    private categoryService: CategoryService, private router: Router
) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      }); }

  @Input() type:any;
  @Input() categoryId:any;


  ngOnInit(): void {


console.log(this.categoryId);

  if(this.categoryId==''){
    this.categoryId="0";
  }
    this.fetchCategoryPath();
  }

  fetchCategoryPath() {
    this.categoryService.fetchCategoryData(this.categoryId).subscribe(
      res => {
        this.categoryDetails = res;
        if (this.categoryDetails && this.categoryDetails['breadCrumpPath']) {
          let a = this.categoryDetails['breadCrumpPath'].split(",");
          let b = (this.categoryDetails['path'] || '').split(",");
          this.items = [];
          for (var i = 0; i < a.length; i++) {
            this.items.push({
                name: a[i],
                url: (b[i] || '') + '/pr'
            });
          }
        }
      },
      error => {
        console.error("Error fetching category path:", error);
      }
    )
  }

    protected _onDestroy = new Subject<void>();

    sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}

